import enviro from 'enviro';
export function createInMemoryCache({
  cacheName = 'unknown'
} = {}) {
  const __cache = new Map();
  const cache = {
    printDebug: () => {
      if (!enviro.deployed()) {
        console.log(cacheName, __cache);
      }
    },
    has: cacheKey => __cache.has(cacheKey),
    get: cacheKey => {
      const cacheValue = __cache.get(cacheKey);
      if (!cacheValue) {
        return null;
      }
      return cacheValue.value;
    },
    set: (cacheKey, value) => {
      __cache.set(cacheKey, {
        value
      });
    },
    delete: cacheKey => {
      __cache.delete(cacheKey);
    },
    clear: () => __cache.clear(),
    deleteAllByPrefix: prefix => {
      for (const key of __cache.keys()) {
        if (key.startsWith(prefix)) {
          __cache.delete(key);
        }
      }
      return Promise.resolve();
    },
    readThrough: ({
      cacheKey,
      fetchValue,
      opts
    }) => {
      if (!(opts !== null && opts !== void 0 && opts.refresh) && cache.has(cacheKey)) {
        return cache.get(cacheKey);
      }
      const value = fetchValue();
      cache.set(cacheKey, value);
      return value;
    }
  };
  return cache;
}